import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { Row, Column } from 'components/shared/Layout';
import { multiply } from 'utils/calculator';
import PropTypes from 'prop-types';
import { formatExtras } from './utils/extras.utils';
import { legShape } from 'constants/propTypes';
import { StyledName } from 'pages/BookingDetails/Extras/Extras.styles';

export const ExtraLegs = ({ extras = [], direction }) => {
  const hasUncancelledExtras = extras.some(({ isCancelled, price }) => !isCancelled && price > 0);

  return hasUncancelledExtras ? (
    formatExtras({ extras }).map(({ firstName, lastName, extras }, index) => (
      <Fragment key={`${direction}--${index}`}>
        <Row>
          <Column span={6} data-testid="pax-name">
            <StyledName>
              {firstName} {lastName}
            </StyledName>
          </Column>
          {extras.map(({ quantity, name, price, currency }) => (
            <Fragment key={`${quantity}--${name}--${price}--${currency}`}>
              <Column start={7} span={8} data-testid="extra-name" key={`${quantity}--${name}`}>
                {quantity} {name}
              </Column>
              <Column span={2} data-testid="extra-price">
                <FormattedCurrency currency={currency} amount={multiply(quantity, price)} />
              </Column>
            </Fragment>
          ))}
        </Row>
        <hr />
      </Fragment>
    ))
  ) : (
    <FormattedMessage id="paymentsTab.none" />
  );
};

ExtraLegs.propTypes = {
  extras: PropTypes.arrayOf(legShape),
  direction: PropTypes.string
};
